"use client";

import JsonLd from "@/components/seo/JsonLd";
import { SITE_ORIGIN } from "@/utils/agentDiscovery";
import { buildBreadcrumbSchema, buildHotelSchema } from "@/utils/schema";
import { usePathname } from "next/navigation";

type HotelJsonLdProps = {
  hotel: any;
};

export default function HotelJsonLd({ hotel }: HotelJsonLdProps) {
  const pathname = usePathname();

  if (!hotel?.name && !hotel?.hotel_code) {
    return null;
  }

  const url = `${SITE_ORIGIN}${pathname || "/hotel"}`;
  const city = hotel?.city || hotel?.city_detail?.name || "Hotels";
  const hotelName = hotel?.name || String(hotel?.hotel_code);

  return (
    <>
      <JsonLd id="live-hotel-jsonld" data={buildHotelSchema(hotel, url)} />
      <JsonLd
        id="live-hotel-breadcrumb-jsonld"
        data={buildBreadcrumbSchema([
          { name: "Home", url: "/" },
          { name: "Hotels", url: "/hotels" },
          { name: city, url: `/hotels?city=${encodeURIComponent(city)}` },
          { name: hotelName, url },
        ])}
      />
    </>
  );
}
